import React from 'react';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useQueryParams from 'hooks/useQueryParams';
import { Box } from '@podiumhq/design-system';
import MobileField from 'components/Trials/components/FormFields/MobileField';
import NameField from 'components/Trials/components/FormFields/NameField';
import { ContentWrapper, Subheading, Title } from 'components/Trials/styles';
import TextMessageDisclaimer from './TextMessageDisclaimer';

const ProfileContent = ({ isSubmitting }) => {
  const { firstName, setFirstName, lastName, setLastName } =
    useTrialsContext() || {};

  const { value: updatePhoneValue } = useQueryParams('updatePhone');

  const modalTitle = updatePhoneValue
    ? 'Update your mobile number'
    : 'Let’s start by setting up your profile.';

  return (
    <ContentWrapper>
      <Title>{modalTitle}</Title>
      <Subheading>Enter your name and mobile phone number.</Subheading>
      <Box maxWidth="500px">
        <NameField
          disabled={isSubmitting}
          fieldName="firstName"
          placeholder="First Name"
          setFieldValue={setFirstName}
          value={firstName}
          maxWidth="400px"
        />

        <NameField
          disabled={isSubmitting}
          fieldName="lastName"
          placeholder="Last Name"
          setFieldValue={setLastName}
          value={lastName}
          maxWidth="400px"
        />

        <MobileField maxWidth="400px" />

        <TextMessageDisclaimer />
      </Box>
    </ContentWrapper>
  );
};

export default ProfileContent;
